var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useCallback } from 'react';
import { apiGetOneRfp } from '@/actions/ProfessionalRfpActions';
import { apiCanCreateProfessionalRfpMember, apiDeleteProfessionalRfpMember, } from '@/actions/ProfessionalRfpMemberActions';
import { RFP_ERROR_MESSAGES } from '@/define/consts/rfp';
import { BAD_RFP_OFFER_MEMBER_ADMIN_NOT_HAS_FORCE_INVITE } from '@/define/response';
import { notify, wrapNotifyError } from '@/helpers/action';
import { getErrorFromErrorObject } from '@/helpers/validate';
import { wrapDispatch } from '@/utils/actions/dispatch';
/**
 * メンバー追加モーダルのuse
 * @deprecated TS化 src/hooks/pages/rfp/useRfpMemberAddModal.tsx
 * @param id
 * @param dispatch
 * @param unmountRef
 * @param onSubmit
 * @param resultMessage
 * @returns {{clearIsMissingRole: (function(): void), onSubmit: (function(*): Promise<void>), hideModal: (function(): void), isMissingRole: boolean, showModal: (function(): void), isShow: boolean}}
 */
const useAddMemberModal = (id, dispatch, unmountRef, onSubmit, resultMessage) => {
    const [isShow, changeModal] = useState(false);
    const [isMissingRole, changeIsMissingRole] = useState(false);
    const [forceInvites, changeForceInvites] = useState([]);
    const clearIsMissingRole = useCallback(() => {
        changeIsMissingRole(false);
        changeForceInvites([]);
    }, [changeIsMissingRole, changeForceInvites]);
    const showModal = useCallback(() => {
        changeForceInvites([]);
        changeModal(true);
    }, [changeForceInvites, changeModal]);
    const hideModal = useCallback(() => {
        changeModal(false);
        clearIsMissingRole();
    }, [changeModal, clearIsMissingRole]);
    const wrapOnSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        const { email } = values;
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const apiValues = Object.assign(Object.assign({}, values), { forceInvite: !!forceInvites.includes(email) });
                changeIsMissingRole(false);
                changeForceInvites((prev) => [...prev.filter((v) => v !== email)]);
                yield wrapDispatch(dispatch, apiCanCreateProfessionalRfpMember(id, apiValues));
                yield onSubmit(apiValues);
                if (!unmountRef.current) {
                    hideModal();
                    if (resultMessage) {
                        notify(resultMessage);
                    }
                }
            }
            catch (e) {
                if (unmountRef.current) {
                    return;
                }
                const { code } = getErrorFromErrorObject(e);
                switch (code) {
                    case BAD_RFP_OFFER_MEMBER_ADMIN_NOT_HAS_FORCE_INVITE:
                        changeIsMissingRole(true);
                        changeForceInvites((prev) => [
                            ...prev.filter((v) => v !== email),
                            email,
                        ]);
                        break;
                    default: {
                        const error = RFP_ERROR_MESSAGES[code];
                        /* eslint-disable react/react-in-jsx-scope */
                        throw error ? _jsx("span", { children: error }) : new Error(e);
                    }
                }
            }
        }));
    }), [
        id,
        hideModal,
        dispatch,
        unmountRef,
        onSubmit,
        resultMessage,
        changeIsMissingRole,
        forceInvites,
        changeForceInvites,
    ]);
    return {
        clearIsMissingRole,
        hideModal,
        isMissingRole,
        isShow,
        onSubmit: wrapOnSubmit,
        showModal,
    };
};
/**
 * メンバー削除モーダルのuse
 * @param id
 * @param members
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
const useDeleteMemberModal = (id, members, dispatch, unmountRef) => {
    const [modalState, changeModal] = useState({
        show: false,
        value: undefined,
    });
    const showModal = useCallback((e) => {
        const memberId = parseInt(e.currentTarget.value, 10);
        const value = members.find((v) => v.id === memberId);
        changeModal({ show: true, value });
    }, [changeModal, members]);
    const hideModal = useCallback(() => {
        changeModal((prevState) => (Object.assign(Object.assign({}, prevState), { show: false })));
    }, [changeModal]);
    const memberId = modalState.value && modalState.value.id;
    const onSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiDeleteProfessionalRfpMember(id, memberId));
            yield wrapDispatch(dispatch, apiGetOneRfp({ path: { id } }, { id }));
            if (!unmountRef.current) {
                changeModal((prevState) => (Object.assign(Object.assign({}, prevState), { show: false })));
                notify('共有メンバーを削除しました。');
            }
        }));
    }), [id, changeModal, dispatch, memberId, unmountRef]);
    return {
        hideModal,
        isShow: modalState.show,
        modalValue: modalState.value,
        onSubmit,
        showModal,
    };
};
export const rfpMemberUseCase = {
    useAddMemberModal,
    useDeleteMemberModal,
};
export default rfpMemberUseCase;
